import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class TranslationsService {

    constructor(private api: ApiService) {
    }

    getLocalizations() {
        return this.api.get(`/admin/localizations`).pipe(map(({result}) => result));
    }

    rebuildCache() {
        return this.api.get(`/admin/rebuildCache`).pipe();
    }

    getList(localeName: string) {
        return this.api.get('/admin/translations/' + localeName).pipe(map(({result}) => result));
    }

    update(localeName: string, key: string, value: string) {
        return this.api.post('/admin/translation/' + localeName, {
            key,
            value
        }).pipe(map(({result}) => result));
    }

    uploadImport(language, file, deleteBefore = true) {
        return this.api.post('/admin/translations/import/' + language, {
          file,
          deleteBefore
        }).pipe(map(response => response));
    }

    delete(translation) {
        if (translation) {
            return this.api.delete('/admin/translation/' + translation.id).pipe(map(response => response));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/translations.service.ts